/* ===== Licensed Logic · "Complete your kit" panel (08/10/2026), same logic as Mahjong and NursePulse =====
   Every [data-add-main] button opens it. "Continue to checkout" empties the cart, adds The Exam Logic System
   plus the ticked extras (1 of each, never 2) and goes to Shopify checkout. The discount itself is applied
   by the Shopify automatic discount; here we only show it. */
(function(){
  var cart=document.getElementById('cartRoot'); if(!cart) return;
  var totalEl=document.getElementById('total'), saveEl=document.getElementById('totalSave');
  var bumps=[].slice.call(cart.querySelectorAll('[data-bump-variant]'));
  var all=cart.querySelector('[data-bump-all]');
  var btn=document.getElementById('checkoutBtn'), err=document.getElementById('cartErr');
  var lastFocus=null, busy=false;
  var track=function(name,data){ try{ if(window.fbq) fbq('trackCustom',name,data||{}); }catch(e){} };
  function money(cents){
    var fmt=cart.dataset.moneyFormat || '$'+'{'+'{amount}}'; // scritto a pezzi: niente graffe doppie (lo snippet passa dal Liquid)
    var amt=(cents/100).toFixed(2).replace(/\.00$/,'');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amt);
  }
  function off(cents,pct){ return Math.round(cents*pct/100); }
  function selected(){ return bumps.filter(function(b){ return b.checked && !b.disabled; }); }
  // One extra: its price is added. Both extras: [pct]% off the whole order, rounded per line like the Shopify automatic discount.
  function update(){
    var pct=+cart.dataset.pct||0, main=+cart.dataset.mainPrice||0, t=main, sel=selected(), save=0;
    sel.forEach(function(b){ t+= +b.dataset.bumpPrice||0; });
    var everyOn=bumps.length>1 && sel.length===bumps.length;
    if(pct>0 && everyOn){ save=off(main,pct); bumps.forEach(function(b){ save+=off(+b.dataset.bumpPrice||0,pct); }); }
    if(all) all.checked=everyOn;
    var m=money(t-save);
    if(totalEl) totalEl.textContent=m;
    if(btn && !busy) btn.firstChild.nodeValue=(btn.dataset.label||'Checkout securely · [total]').replace('[total]',m);
    if(saveEl){ saveEl.hidden=!save; saveEl.textContent=(cart.dataset.saveLabel||'You save [amount]').replace('[amount]',money(save)); }
  }
  // While the panel is open, the page behind it is inert (keyboard and screen readers stay in the panel).
  function setInert(on){ [].forEach.call(document.body.children,function(el){ if(el.contains(cart) || el.tagName==='SCRIPT') return; if(on) el.setAttribute('inert',''); else el.removeAttribute('inert'); }); }
  function open(where){
    lastFocus=document.activeElement; cart.hidden=false; document.body.classList.add('llo-open'); setInert(true);
    var sheet=cart.querySelector('.llo-sheet'); if(sheet) sheet.focus();
    track('KitPanelOpen',{location:where||'other'});
  }
  function close(){
    if(busy) return;
    cart.hidden=true; document.body.classList.remove('llo-open'); setInert(false);
    if(lastFocus) lastFocus.focus();
  }
  document.addEventListener('click',function(e){
    var opener=e.target.closest('[data-add-main]');
    if(opener){ e.preventDefault(); open(opener.dataset.cta); }
    else if(e.target.closest('[data-close-cart]')){ close(); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !cart.hidden) close(); });
  if(all) all.addEventListener('change',function(){ bumps.forEach(function(b){ if(!b.disabled) b.checked=all.checked; }); update(); });
  bumps.forEach(function(b){ b.addEventListener('change',update); });
  update();

  // Checkout: replace the cart with the main product plus the chosen extras, then go to Shopify checkout.
  function checkout(items){
    if(busy) return;
    busy=true; if(err) err.hidden=true;
    btn.disabled=true; btn.firstChild.nodeValue=btn.dataset.wait||'One moment…';
    var root=(window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root+'cart/clear.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(){ return fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})}); })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.href=root+'checkout'; })
      .catch(function(){ busy=false; btn.disabled=false; update(); if(err) err.hidden=false; });
  }
  if(btn){
    btn.addEventListener('click',function(){
      var items=[{id:+cart.dataset.mainVariant, quantity:1}];
      selected().forEach(function(b){ items.push({id:+b.dataset.bumpVariant, quantity:1}); });
      track('KitPanelCheckout',{extras:items.length-1});
      checkout(items);
    });
    var no=cart.querySelector('[data-just-main]');
    if(no) no.addEventListener('click',function(){ track('KitPanelCheckout',{extras:0}); checkout([{id:+cart.dataset.mainVariant, quantity:1}]); });
  }
  // Back button from checkout (bfcache): unlock the button again.
  window.addEventListener('pageshow',function(e){ if(e.persisted){ busy=false; if(btn) btn.disabled=false; update(); } });
})();
